// © Copyright 2026 Emman Consulting SAS
import React, { useState, useMemo } from "react";
import { TEAMS, GROUP_THEMES, sk } from "../../data/albumData.js";
import { I18N } from "../../i18n.js";
import FlagImg from "../ui/FlagImg.jsx";

const GroupCard = React.memo(function GroupCard({ g, col, onTap, onReset, onModal, filter, lang }) {
  const [open, setOpen] = useState(false);
  const theme = GROUP_THEMES[g.id] || GROUP_THEMES.A;
  const t = I18N[lang] || I18N.es;

  const owned = useMemo(
    () => g.teams.reduce((acc, tc) => {
      let n = 0;
      for (let i = 1; i <= 20; i++) if (col[sk(tc, i)]?.owned) n++;
      return acc + n;
    }, 0),
    [col, g]
  );

  const total = g.teams.length * 20;
  const gp = Math.round(owned / total * 100);
  const grad = `linear-gradient(135deg,${theme.gs}cc 0%,${theme.gm}99 50%,${theme.ge}55 100%)`;

  return (
    <div className="gcard">
      <div className="gbg" style={{ background: grad }} />
      <div className="gwave" />
      <div className="ginner">
        <div className="ghdr" onClick={() => setOpen((o) => !o)}>
          <div className="gbadge">{g.id}</div>
          <div className="gmeta">
            <div className="gname">{t.group} {g.id}</div>
            <div className="gflags">
              {g.teams.map((tc) => (
                <FlagImg key={tc} cc={TEAMS[tc]?.cc} style={{ width: 18, height: 12 }} />
              ))}
            </div>
          </div>
          <div className="gright">
            <div>
              {filter !== "missing" && <div className="gpct">{gp}%</div>}
              <div className="gcnt">{owned}/{total}</div>
            </div>
            <span className={"gchev" + (open ? " open" : "")}>▼</span>
          </div>
        </div>
        {open && (
          <div className="tlist">
            {g.teams.map((tc) => {
              const td = TEAMS[tc];
              if (!td) return null;
              let oc = 0;
              for (let i = 1; i <= 20; i++) if (col[sk(tc, i)]?.owned) oc++;
              return (
                <div key={tc} className="trow">
                  <div className="ttop" onClick={() => onModal(tc)}>
                    <div className="tleft">
                      <FlagImg cc={td.cc} className="tfimg" />
                      <div>
                        <div className="tname">{lang === "en" ? (td.en || td.n) : td.n}</div>
                        <div className="tcode">{tc}</div>
                      </div>
                    </div>
                    <div className="town">{oc}/20</div>
                  </div>
                  <div className="sdots">
                    {Array.from({ length: 20 }, (_, i) => {
                      const key = sk(tc, i + 1);
                      const s = col[key] || { owned: false, quantity: 0 };
                      const isDupe = s.owned && s.quantity > 0;
                      const numStr = (i + 1) < 10 ? "0" + (i + 1) : "" + (i + 1);
                      if (filter === "missing" && s.owned) return null;
                      if (filter === "dupes" && !isDupe) return null;
                      return (
                        <div
                          key={key}
                          className={"sdot" + (isDupe ? " dupe" : s.owned ? " owned" : "")}
                          data-qty={isDupe ? "×" + s.quantity : ""}
                          data-num={numStr}
                          title={key}
                          onClick={(e) => { e.stopPropagation(); onTap(key); }}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
});

export default GroupCard;
